import { useCallback, useContext } from "react";
import { brandInfo } from "../../../constant";
import { useElement, useLocale } from "../../../hooks";
import { useFranchiseCTA } from "./hooks";
import "./style.scss";
import { AppContext } from "../../../context";

export const FranchiseCTA = () => {
  const { t } = useLocale();
  const { selectors } = useContext(AppContext);
  const logo = selectors?.getLogo() || brandInfo.logo;
  const Img = useElement("Img");
  const Link = useElement("Link");
  const {
    franchiseTiles,
    activeFranchise,
    setactiveFranchise,
    navigateToStoreLocator,
  } = useFranchiseCTA();
  const renderFranchiseCtaTiles = useCallback(() => {
    return franchiseTiles.slice(1).map((e, i) => {
      return (
        <li key={i}>
          <Img src={e} onClick={() => setactiveFranchise(e)} />
          {i === franchiseTiles.length - 2 && (
            <span onClick={navigateToStoreLocator}>{t("viewAll")}</span>
          )}
        </li>
      );
    });
  }, [Img, franchiseTiles, navigateToStoreLocator, setactiveFranchise, t]);
  return (
    <section className="franchise-cta-section mb60-mbs40">
      <div className="wrapper jumbo-container">
        <div className="franchise-cta-slider">
          <ul className="franchise-cta-tiles">{renderFranchiseCtaTiles()}</ul>
          <div className="franchise-cta-frame">
            <Img src={activeFranchise} />
          </div>
        </div>
        <div className="franchise-cta-content">
          <div className="logo-block">
            <Img
              source="internal"
              className="franchise-logo"
              src={logo}
              title={brandInfo.name.uppercase}
              alt={brandInfo.name.uppercase}
            />
            <span>{t("franchise")}</span>
          </div>
          <h2 className="head">{t("franchiseCTA.title")}</h2>
          <p>
            {t("franchiseCTA.description").replace("{brand}", brandInfo.name.capital)}
          </p>
          <p className="mb30">
            <b>{t("franchiseCTA.subDescription").replace("{brand}", brandInfo.name.capital)}</b>
          </p>
          <Link
            className="btn btn-primary btn-big"
            href="/franchise-with-us"
            title={t("becomePartner")}
          >
            {t("franchiseCTA.apply")}
          </Link>
        </div>
      </div>
    </section>
  );
};
